import styled from 'styled-components';

import { basicCaptionTextStyle, Text } from '@dreryk/react-components';

export const StyledPractitionerResourceLabelContent = styled.div`
   display: flex;
   flex-direction: column;
   align-self: center;
`;

StyledPractitionerResourceLabelContent.displayName = 'StyledPractitionerResourceLabelContent';

export const StyledRolesText = styled(Text)`
   ${basicCaptionTextStyle};
`;

StyledRolesText.displayName = 'StyledRolesText';
